import { createPartyRequest } from './helper';
export const getPartyNotes = createPartyRequest({
    route: '/party/parties/:partyNo/notes',
    method: 'get',
    source: 'data',
});
